
import { supabase } from "@/lib/supabase";
import { DBMessage } from "@/types/message";
import { convertToDBMessage } from "./types";

export async function findRelatedMessages(
  refundRequestId: string,
  messageId: string
): Promise<DBMessage[]> {
  try {
    // First, check if this is an original message or a regenerated one
    const { data: message, error: messageError } = await supabase
      .from("messages")
      .select("*")
      .eq("refund_request_id", refundRequestId)
      .eq("id", messageId)
      .single();
    
    if (messageError) throw messageError;
    
    let query = supabase
      .from("messages")
      .select("*")
      .eq("refund_request_id", refundRequestId);
    
    // If this message has a related_to_message_id, it's a regenerated version
    if (message.related_to_message_id) {
      // Find original and all regenerations
      query = query.or(`id.eq.${message.related_to_message_id},related_to_message_id.eq.${message.related_to_message_id}`);
    } else {
      // This is an original, find all its regenerations
      query = query.or(`id.eq.${messageId},related_to_message_id.eq.${messageId}`);
    }
    
    const { data: relatedMessages, error } = await query;
    
    if (error) throw error;
    
    return (relatedMessages || []).map(convertToDBMessage);
  } catch (error) {
    console.error("Error finding related messages:", error);
    return [];
  }
}
